import { useCallback, useEffect, useRef } from 'react';
import { useDispatch } from 'react-redux';

/**
 * A hook to simplify the use of React-Redux useDispatch.
 * Simply wraps the function in a dispatch call and watches for updates.
 * @param func The redux action you want dispatched
 * @returns The wrapped dispatch function
 */
export function useMiaDispatch<T>(func: () => T) {
  const callback = useRef(func);
  const dispatch = useDispatch();

  useEffect(() => {
    callback.current = func;
  }, [func]);

  return useCallback(() => dispatch(callback.current()), [callback.current]);
}
